/* eslint-disable prettier/prettier */
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

function CommonFooter() {
  return (
    <Box
      sx={{
        mt: 4,
        bgcolor: "#b71c2a",
        color: "#f8fafc",
        px: { xs: 1.5, sm: 2.5, md: 3.5 },
        py: 5,
        fontFamily: '"Segoe UI", "Helvetica Neue", Arial, sans-serif',
      }}
    >
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Typography sx={{ color: "#ffd9de", fontWeight: 700, mb: 1.5, letterSpacing: "0.2px" }}>
            Address
          </Typography>
          <Typography sx={{ fontWeight: 700, letterSpacing: "0.15px", fontSize: "1.35rem" }}>
            KLJ Lahiru traders
          </Typography>
          <Typography
            sx={{ maxWidth: 450, fontWeight: 500, letterSpacing: "0.1px", fontSize: "1.1rem" }}
          >
            Kegalle Road, Wattarama
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "center" } }}
        >
          <Box
            sx={{
              mt: { xs: 0, md: 2 },
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Typography sx={{ color: "#ffd9de", fontWeight: 700, mb: 1.2, letterSpacing: "0.2px" }}>
              Contact Information
            </Typography>
            <Typography
              sx={{ color: "#ffffff", fontSize: "2.4rem", fontWeight: 800, letterSpacing: "0.4px" }}
            >
              0762778573
            </Typography>
            <Typography
              sx={{
                fontWeight: 600,
                textAlign: "left",
                letterSpacing: "0.15px",
              }}
            >
              (Daily operating hours 8.00a.m to 8.00p.m)
            </Typography>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" } }}
        >
          <Box>
            <Typography sx={{ color: "#ffd9de", fontWeight: 700, mb: 1.5 }}>
              Customer Service
            </Typography>
            <Stack spacing={1}>
              <Typography
                component={Link}
                to="/authentication/terms-and-conditions"
                sx={{
                  color: "inherit",
                  textDecoration: "none",
                  fontWeight: 500,
                  letterSpacing: "0.1px",
                }}
              >
                Terms and Conditions
              </Typography>
            </Stack>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 3.2, borderColor: "#fda4af" }} />

      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
        spacing={2}
        sx={{ mt: 3 }}
      >
        <Stack direction="row" spacing={1.2}>
          <Box
            component="a"
            href="https://www.facebook.com/"
            target="_blank"
            rel="noreferrer"
            sx={{
              width: 42,
              height: 42,
              border: "1px solid #ffd9de",
              borderRadius: 1.2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#ffd9de",
              fontWeight: 700,
              textDecoration: "none",
            }}
          >
            f
          </Box>
        </Stack>
        <Typography
          sx={{
            color: "#ffe4e6",
            fontWeight: 700,
            fontSize: "0.95rem",
            letterSpacing: "0.35px",
            textTransform: "none",
          }}
        >
          Developed by Argentexa
        </Typography>
      </Stack>
    </Box>
  );
}

export default CommonFooter;
